class FruitCartDiscount extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.summaryId = this.dataset.summaryId;

    this.form = this.querySelector('form');
    this.errorWrap = this.querySelector('[data-fruit-error]');
    this.errorCode = this.querySelector('[data-fruit-error-code]');
    this.errorShipping = this.querySelector('[data-fruit-error-shipping]');

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit);
    }

    this.addEventListener('click', this.onClickRemove);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    this.removeEventListener('click', this.onClickRemove);
  }

  hideErrors() {
    if (!this.errorWrap) return;
    this.errorWrap.classList.add('fruit-hidden');
    this.errorCode?.classList.add('fruit-hidden');
    this.errorShipping?.classList.add('fruit-hidden');
  }

  showError(type) {
    if (!this.errorWrap) return;
    this.errorWrap.classList.remove('fruit-hidden');

    if (type === 'discount_code') {
      this.errorCode?.classList.remove('fruit-hidden');
      this.errorShipping?.classList.add('fruit-hidden');
    } else {
      this.errorShipping?.classList.remove('fruit-hidden');
      this.errorCode?.classList.add('fruit-hidden');
    }
  }

  existingDiscounts() {
    return Array.from(this.querySelectorAll('[data-discount-code]'))
      .map((el) => el.dataset.discountCode)
      .filter(Boolean);
  }

  onSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!this.sectionId || !this.summaryId) return;

    const input = this.form?.querySelector('input[name="discount"]');
    if (!(input instanceof HTMLInputElement)) return;

    const code = (input.value || '').trim();
    if (!code) return;

    const existing = this.existingDiscounts();
    if (existing.includes(code)) return;

    this.hideErrors();

    const payload = {
      discount: [...existing, code].join(','),
      sections: [this.sectionId],
    };

    const data = await this.postCartUpdate(payload);
    if (!data) return;

    // 1) erro de cupom inválido
    const invalid = (data.discount_codes || []).find((d) => d.code === code && d.applicable === false);
    if (invalid) {
      input.value = '';
      this.showError('discount_code');
      return;
    }

    // 2) lógica Horizon: cupom "aplicável" no payload mas não aparece na UI => normalmente é shipping discount
    const nextSummary = this.getNextSummaryFromSections(data);
    if (!nextSummary) return;

    const nextCodes = Array.from(nextSummary.querySelectorAll('[data-discount-code]'))
      .map((el) => el.dataset.discountCode)
      .filter(Boolean);

    const payloadSaysApplicable = (data.discount_codes || []).some(
    (d) => d.code === code && d.applicable === true
    );

if (payloadSaysApplicable) {
  const nextSummary = this.getNextSummaryFromSections(data);
  if (nextSummary) {
    this.replaceSummary(nextSummary);
  }

  this.hideErrors(); // 🔥 LIMPA ERROS VISUAIS
  input.value = '';

  document.dispatchEvent(
    new CustomEvent('fruit:cart:discount-updated', { detail: data })
  );
  return;
}


    // sucesso: substitui SOMENTE o resumo (não mexe na lista de itens)
    this.replaceSummary(nextSummary);
    document.dispatchEvent(new CustomEvent('fruit:cart:discount-updated', { detail: data }));
  };

  onClickRemove = async (event) => {
    const btn = event.target.closest('[data-fruit-remove]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    if (!this.sectionId || !this.summaryId) return;

    const pill = btn.closest('[data-discount-code]');
    if (!pill) return;

    const code = pill.dataset.discountCode;
    if (!code) return;

    const existing = this.existingDiscounts();
    const idx = existing.indexOf(code);
    if (idx === -1) return;

    existing.splice(idx, 1);

    this.hideErrors();

    const payload = {
      discount: existing.join(','),
      sections: [this.sectionId],
    };

    const data = await this.postCartUpdate(payload);
    if (!data) return;

    const nextSummary = this.getNextSummaryFromSections(data);
    if (!nextSummary) return;

    this.replaceSummary(nextSummary);
    document.dispatchEvent(new CustomEvent('fruit:cart:discount-updated', { detail: data }));
  };

  async postCartUpdate(payload) {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  getNextSummaryFromSections(data) {
    const html = data?.sections?.[this.sectionId];
    if (!html) return null;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.getElementById(this.summaryId);
  }

  replaceSummary(nextSummaryEl) {
    const current = document.getElementById(this.summaryId);
    if (!current) return;

    // substitui o nó inteiro do resumo por um novo (seguro, pois é só a área de totals/cupom/botões)
    current.replaceWith(nextSummaryEl);
  }
}

if (!customElements.get('fruit-cart-discount')) {
  customElements.define('fruit-cart-discount', FruitCartDiscount);
}

